<template>
  <div class="liquor-login">
    <Background :map="false" />
    <img class="logo" src="@/assets/logo（酒专栏）.png" />
    <div class="title">为你打开酒世界</div>
    <div class="box-card">
      <el-form ref="form" :model="form">
        <img class="enter" src="/liquor/入口icon.png" />
        <div class="welcome">欢迎登录</div>
        <el-form-item label="工号" placeholder="请输入工号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" placeholder="请输入密码">
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Background from "@/components/liquor/Background";
/**
 * 我有个基本的想法，不知道可不可行。
 * 1. 点击百科的链接的时候，你们前端给你们后端发个请求GetFreshWikiUserSession.
 * 2. 你们接到这个请求的时候，获取session里保存的OA账号信息，然后使用这个来登录生鲜百科，返回的信息里面带有Session。
 * 3. 你们返回给前端，然后带到链接地址里，开始跳转过来。
 * 4. 我把跳转里携带的Session信息写入Cookie，这个时候就不需要再登录了。
 */
export default {
  name: "Login",
  components: {
    Background
  },
  data() {
    return {
      form: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async onSubmit() {
      await this.$store.dispatch("login", {
        params: this.form
      });

      if (this.$store.state.sys.sysUser.get.id) {
        this.$router.push("/liquor/index");
      } else {
        this.$message.error("账号或密码错误，请重新输入！");
      }
    }
  }
};
</script>

<style lang="less">
.liquor-login {
  .el-card__body {
    padding: 0;
  }
  .el-form-item__label {
    background: rgba(0, 0, 0, 1);
    font-size: 12px;
    color: #e4c896;
    width: 52px;
    line-height: 20px;
    text-align: center;
    padding: 0;
  }
  .el-form-item__content {
    .el-button--primary {
      margin-top: 20px;
      width: 100%;
      background: rgba(0, 0, 0, 1);
      color: #e4c896;
      border-color: black;
    }
  }
  .el-form-item__label {
    // min-height: 10px;
  }
}
</style>

<style lang="less" scoped>
.liquor-login {
  width: 100%;
  height: 100vh;
  // background: url("/liquor/轮播背景图4.jpg");
  // background-size: cover;

  position: relative;

  text-align: center;

  // display: flex;
  // align-items: center;
  // justify-content: center;

  .liquor-background {
    position: absolute;
  }

  .logo {
    margin-top: 110px;
    width: 366px;
  }

  .title {
    margin-top: 30px;
    height: 25px;
    font-size: 18px;
    font-weight: 300;
    color: rgba(228, 200, 150, 1);
    line-height: 25px;
    letter-spacing: 20px;
  }

  .box-card {
    margin: 0 auto;
    margin-top: 70px;
    width: 366px;
    height: 366px;

    background: white;

    form {
      width: 240px;
      // padding: 46px;
      display: inline-block;
      vertical-align: top;

      .enter {
        width: 100px;
        height: 100px;
        margin-top: -50px;
      }

      .welcome {
        margin-top: 30px;
        margin-bottom: 10px;
        height: 22px;
        font-size: 22px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
      }
    }
  }
}
</style>
